module.exports = __webpack_public_path__ + "static/WEDDING E&M-483-3ef07398451532bf9eb8157e12d8282b.jpg";